<template>
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_151_1967)">
      <path
        d="M12.56 8.16634L13.7067 7.02634H13.6934C14.3071 6.39036 14.6434 5.53682 14.6284 4.65312C14.6134 3.76942 14.2484 2.92778 13.6134 2.313C12.9913 1.71313 12.1609 1.37793 11.2967 1.37793C10.4325 1.37793 9.60208 1.71313 8.98004 2.313L7.83337 3.453M3.44667 7.83301L2.30667 8.97301C1.69291 9.60898 1.35662 10.4625 1.37162 11.3462C1.38661 12.2299 1.75168 13.0716 2.38667 13.6863C3.0087 14.2862 3.83917 14.6214 4.70333 14.6214C5.56749 14.6214 6.39796 14.2862 7.02 13.6863L8.16 12.5463M1.33337 1.33301L14.6667 14.6663"
        stroke="#9CA3AF"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_151_1967">
        <rect
          width="16"
          height="16"
          fill="white"
        />
      </clipPath>
    </defs>
  </svg>
</template>
